"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("src/components/Box"));
var styled_components_1 = __importDefault(require("styled-components"));
var grid_gap_1 = __importDefault(require("./utilities/grid-gap"));
var grid_column_gap_1 = __importDefault(require("./utilities/grid-column-gap"));
var grid_row_gap_1 = __importDefault(require("./utilities/grid-row-gap"));
var grid_templeate_areas_1 = __importDefault(require("./utilities/grid-templeate-areas"));
var GridComponent = (0, styled_components_1.default)(Box_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  grid-auto-flow: ", ";\n  grid-auto-rows: ", ";\n  grid-auto-columns: ", ";\n  place-items: ", "; \n"], ["\n  display: grid;\n  grid-template-columns: ", ";\n  grid-template-rows: ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  grid-auto-flow: ", ";\n  grid-auto-rows: ", ";\n  grid-auto-columns: ", ";\n  place-items: ", "; \n"])), function (_a) {
    var templateColumns = _a.templateColumns;
    return templateColumns;
}, function (_a) {
    var templateRows = _a.templateRows;
    return templateRows;
}, grid_templeate_areas_1.default, grid_gap_1.default, grid_column_gap_1.default, grid_row_gap_1.default, function (_a) {
    var autoFlow = _a.autoFlow;
    return autoFlow;
}, function (_a) {
    var autoRows = _a.autoRows;
    return autoRows;
}, function (_a) {
    var autoColumns = _a.autoColumns;
    return autoColumns;
}, function (_a) {
    var placeItems = _a.placeItems;
    return placeItems;
});
var Grid = function (_a) {
    var templateColumns = _a.templateColumns, templateRows = _a.templateRows, autoFlow = _a.autoFlow, autoRows = _a.autoRows, autoColumns = _a.autoColumns, placeItems = _a.placeItems, children = _a.children, rest = __rest(_a, ["templateColumns", "templateRows", "autoFlow", "autoRows", "autoColumns", "placeItems", "children"]);
    return (react_1.default.createElement(GridComponent, __assign({ "data-testid": "grid-component", templateColumns: templateColumns, templateRows: templateRows, autoFlow: autoFlow, autoRows: autoRows, autoColumns: autoColumns, placeItems: placeItems }, rest), children));
};
exports.default = Grid;
var templateObject_1;
